import { render, staticRenderFns } from "./movimentiTable.vue?vue&type=template&id=094dd598&"
import script from "./movimentiTable.vue?vue&type=script&lang=ts&"
export * from "./movimentiTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports